// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","footer__line":"footer_footer__line__RZOdE","footer__inner":"footer_footer__inner__X2IEl"};